/**
 * toggleButtonGroupDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { get } from 'lodash-es';

toggleButtonGroupDirective.$inject = [];

export function toggleButtonGroupDirective() {
    return {
        restrict: 'E',
        transclude: true,
        //language=HTML
        template: `
            <md-button class="app-outline"
                       ng-repeat="button in buttons"
                       ng-click="select(button)"
                       ng-class="{ selected: ui.selectedButton.value === button.value }">
                <md-icon ng-if="ui.selectedButton.value === button.value && button.value">
                    check
                </md-icon>

                {{ button.label }}
            </md-button>
        `,
        scope: {
            buttons: '=buttons',
            value: '=value',
        },
        link: function(scope) {
            const ui = (scope.ui = {
                selectedButton: null,
            });

            scope.select = function(button) {
                ui.selectedButton = button;

                scope.value = get(button, 'value');
            };

            // Main
            scope.$watch('value', _valueWatcher, true);

            // Functions

            function _valueWatcher(value) {
                if (value === undefined) {
                    ui.selectedButton = undefined;
                } else {
                    ui.selectedButton = scope.buttons.find(button => {
                        // eslint-disable-next-line eqeqeq
                        return button.value === value;
                    });
                }
            }
        },
    };
}

let buttonId = 0;

export class ButtonDefinition {
    id: number;

    constructor(public label, public value) {
        this.id = buttonId++;
    }
}
